import SectionLabel from '../SectionLabel'

// Permit & cost table styled like official paperwork: mono right-aligned costs
// (ledger columns), thin map-rule separators, uppercase headers, no card/fill.
// Reads trek.permits — [{ name, authority?, cost }]. 'TODO: ...' values render
// muted so a missing figure is visible, never invented.
const isTodo = v => typeof v === 'string' && v.trim().startsWith('TODO')

export default function TrekPermits({ trek }) {
  const permits = trek?.permits || []
  if (!permits.length) return null

  return (
    <div>
      <SectionLabel>Permits · Officialdom</SectionLabel>
      <h2 className="section-title" style={{ fontSize: '28px', marginBottom: '8px' }}>Permits &amp; costs.</h2>
      <p style={{ fontSize: '14px', color: 'var(--color-text-secondary)', maxWidth: '640px', marginBottom: '32px', lineHeight: 1.6 }}>
        {trek.name} requires the permits below — all mandatory, all handled for you and
        included in your trip price. Figures are current 2026 government rates.
      </p>

      {/* Column headers — trail-sign uppercase */}
      <div style={{
        display: 'grid', gridTemplateColumns: 'minmax(0,1fr) auto', gap: '24px',
        alignItems: 'baseline', paddingBottom: '10px', borderBottom: '2px solid var(--color-text)',
      }}>
        <div style={{ fontSize: '11px', letterSpacing: '2px', textTransform: 'uppercase', color: 'var(--color-text-secondary)', fontWeight: 500 }}>
          Permit
        </div>
        <div style={{ fontSize: '11px', letterSpacing: '2px', textTransform: 'uppercase', color: 'var(--color-text-secondary)', fontWeight: 500, textAlign: 'right' }}>
          Cost
        </div>
      </div>

      {/* Rows — thin map-rule separators, no fills */}
      {permits.map((p, i) => (
        <div
          key={p.name || i}
          style={{
            display: 'grid', gridTemplateColumns: 'minmax(0,1fr) auto', gap: '24px',
            alignItems: 'baseline', padding: '18px 0',
            borderBottom: '1px solid var(--color-rule)',
          }}
        >
          <div>
            <div style={{ fontFamily: 'var(--font-heading)', fontSize: '16px', fontWeight: 600, lineHeight: 1.3 }}>
              {p.name}
            </div>
            {p.authority && (
              <div style={{
                fontSize: '12px', marginTop: '3px',
                color: isTodo(p.authority) ? 'var(--color-accent-cool)' : 'var(--color-text-secondary)',
                fontStyle: isTodo(p.authority) ? 'italic' : 'normal', opacity: isTodo(p.authority) ? 0.7 : 1,
              }}>
                {p.authority}
              </div>
            )}
          </div>
          <div
            className="data"
            style={{
              textAlign: 'right', fontSize: '14px',
              // wrap long cost strings (e.g. Manaslu's) instead of forcing the
              // row wider than a phone screen — this was causing horizontal scroll
              overflowWrap: 'anywhere',
              color: isTodo(p.cost) ? 'var(--color-accent-cool)' : 'var(--color-text)',
              fontStyle: isTodo(p.cost) ? 'italic' : 'normal', opacity: isTodo(p.cost) ? 0.7 : 1,
            }}
          >
            {p.cost}
          </div>
        </div>
      ))}

      <p style={{ fontSize: '12px', color: 'var(--color-text-secondary)', marginTop: '16px', fontStyle: 'italic' }}>
        Figures are current-season estimates; final permit fees are confirmed at booking.
      </p>
    </div>
  )
}
